export default {
  //el button按钮
  commonBtnConfirm: '确定',
  commonBtnCancel: '取消',
  commonBtnView: '查看',
  commonBtnAdd: '添加',
  commonBtnEdit: '编辑',
  commonBtnDel: '删除',
  commonBtnBatchDel: '批量删除',
  commonBtnHint: '提示',
  commonBtnSearch: '搜索',
  commonBtnClear: '清空',
  commonBtnSearchOpen: '展开',
  commonBtnSearchShrink: '收起',
  commonBtnResetPassword: '重置密码',
  commonBtnDisabled: '禁用',
  commonBtnEnabled: '启用',
  commonBtnBalanceSet: '余额设置',
  commonBtnPrivateAccount: '内测账号',
  commonBtnOpenGame: '启用游戏',
  commonBtnPauseGame: '暂停游戏',
  commonBtnUser: '用户',
  commonBtnAuthorize: '授权',
  commonBtnLoginAccount: '登录账号',
  commonBtnWhitelist: 'IP白名单',
  commonBtnGameSetting: '游戏配置',
  commonBtnMenuPermission: '平台菜单权限',
  commonBtnRegisterLogin: '注册登录',
  commonBtnGameConfig: '游戏配置',
  commonBtnRetentionConfig: '数据存留配置',
  commonBtnAddSubitem: '添加子项',
  commonBtnDetails: '详情',
  commonBtnBatchEdit: '批量编辑',
  commonBtnUpdate: '立即更新',
  commonBtnUnUpdate: '保存但暂不更新',
  commonBtnPlatformUpdate: '平台更新',
  commonBtnBatchUpdate: '批量更新至最新',
  commonBtnUpdateNew: '更新至最新',
  commonBtnSave: '保存',
  commonBtnOpen: '开启',
  commonBtnClose: '关闭',
  commonBtnAdd1: '添加',
  commonBtnBlack: '黑名单',
  commonBtnConfig: '奖池配置',
  commonBtnManage: '管理',
  commonBtnCancelBlack: '取消黑名单',
  commonBtnCancelAllBlack: '批量取消黑名单',
  commonBtnSend: '提交',
  commonBtnConfirmEdit: '确认修改',
  commonBtnDefaultMenu: '使用默认菜单',
  commonBtnSetDefaultMenu: '设置默认菜单',
  commonBtnSensitiveWord: '敏感词库',
  commonBtnSoonSend: '立即发送',
  commonBtnBack: '撤回',
  commonBtnSync: '同步',
  commonBtnRetry: '重试',
  commonBtnBatchState: '批量编辑状态',
  commonBtnSyncData: "一键同步",
  commonBtnQrcode: "查看二维码",
  commonBtnSecretKey: "重置密钥",
  commonBtnUnlock: "解锁",
  commonBtnOpenVerify: "开启验证",
  commonBtnCloseVerify: "关闭验证",
  commonBtnCancelBanSpeak: '取消禁言',
  commonBtnCancelAllBanSpeak: '批量取消禁言',
  commonBtnDictConfig: '字典配置',

  //text
  commonTextNormal: '正常',
  commonTextDisabled: '禁用',
  commonTextTreeSelect1: '收起所有',
  commonTextTreeSelect2: '展开所有',
  commonTextTreeSelect3: '全部勾选',
  commonTextTreeSelect4: '取消全选',
  commonTextTotal: "合计",
  commonTextSyncData: "数据同步",

  //el message提示
  commonMessageBox: '确定将选择数据删除?',
  commonMessageBox2: '请选择至少一条数据',
  commonMessageBox3: '确定启用/禁用该条数据?',
  commonMessageBox4: '设置成功',
  commonMessageBox5: '确定将选择账号密码重置为qwerty1234567890',
  commonMessageBox6: '确定将选择数据更新至最新?',
  commonMessageBox7: '确定将选择数据同步?',
  commonMessageBox8: '确定将选择数据重试?',
  commonMessageBox9: '确定将选择数据启用游戏?',
  commonMessageBox10: '确定将选择数据暂停游戏?',
  commonMessageBox11: '确定撤单，撤单后金额将无法撤回?',
  commonMessageBox12: '确定重置谷歌密钥？重置后原二维码和谷歌密钥不可用。',
  commonMessageBox13: '确定解锁？解锁后可正常使用。',
  commonMessageBox14: '冻结解冻数据无异常。',
  commonMessageBox15: '确定将选择数据开启/关闭?',
  commonMessageEnable: "确定启用",
  commonMessageDisable: "确定禁用",
  commonMessageAddSuccess: "添加成功",
  commonMessageUpdateSuccess: "操作成功",
  commonMessageRemoveSuccess: "删除成功",
  commonMessageBigDataTime: "数据量较大，请耐心等待",

  commontTips: '提示',
  commonTipSelect: "请选择",
  commonTipInput: "请输入",
  commonTipStartTime: "开始时间",
  commonTipEndTime: "结束时间",
  commonTipStart: "开始",
  commonTipEnd: "结束",

  commonUploading: "上传中",
  commonUploadSize: "请上传小于2M的图片",
  commonUploadError: "上传图片失败",

  commonTimeToday: "今日",
  commonTimeYesterday: '昨日',
  commonTimeNearly3: '近3天',
  commonTimeNearly7: '近7天',
  commonTimeNearly15: '近15天',
  commonTimeNearly30: '近30天',
  commonTimeNearly60: '近60天',
  commonTimeNearly90: '近90天',

  //el placeholder
  commonPlaceholderIp: '请输入IP',
  commonPlaceholderRemake: '请输入备注',
  commonPlaceholderStatus: '请选择状态',
  commonPlaceholderNumber: '请输入1-10位纯数字',
  commonPlaceholderPlatform: '请选择平台',
  commonPlaceholderValidate1: '请输入1-10位纯数字',
  commonPlaceholderValidate2: '请输入大于0的1-10位纯数字',
  commonPlaceholderValidate3: '请输入1-100个字符',
  commonPlaceholderValidate4: '请输入5~15位字母或数字组合',
  commonPlaceholderValidate5: '请输入16~32位字母或数字组合',
  commonPlaceholderValidate6: '请输入1-20位字符',
  commonPlaceholderValidate7: '请输入3~8位字母或数字组合',
  commonPlaceholderValidate8: '请输入0-100数字,最多可保留两位小数',
  commonPlaceholderValidate9: '只能输入整数排序',
  commonPlaceholderValidate10: '请输入32位字符',
  commonPlaceholderValidate11: '请输入8位字符',
  commonPlaceholderValidate12: '登录密码和确认密码输入不一致',
  commonPlaceholderValidate13: '请输入1-8位纯数字',

  commonPlaceholderAccount: '请输入账号',
  commonPlaceholderPassword: '请输入密码',
  commonPlaceholderTreeOperate: '树操作',

  commonNav1: '个人中心',
  commonNav2: '其他',
  commonNav3: '首页',

  commonEmptyData: '暂无数据'
}
